import event from '../../event'
const handleNext = (promises, next) => {
  Promise.all(promises).then(next)
  .catch(err => {
    console.log(err)
    event.$emit('toast', { type: 'error', message: 'Unable to load resources' })
    next(false)
  }).then(() => event.$emit('loading-off', {}))
}

export {
  handleNext
}



// WEBPACK FOOTER //
// ./src/modules/helpers/RouteHelpers.js